import * as React from 'react'
import SpinnerOverlay from '../../../shared/spinner_overlay'
import TemplatePreviewContent from './template_preview_content'
import { OrderElement } from '../order_types'


type TemplatePreviewProps = {
  currentElement: OrderElement
  currentTemplate?: number
  currentTemplateData: any
  currentReplaceElementId: string
  allowImageUpload: boolean
  addElement: (element: any, key: string) => void
  uploaderOptions: any
  initUploader?: (id: any, options: any) => void
}

function TemplatePreview(props: TemplatePreviewProps) {
  const {
    currentTemplate,
    currentTemplateData,
    currentElement,
    currentReplaceElementId,
    addElement,
    allowImageUpload,
    uploaderOptions,
    initUploader,
  } = props
  if (!currentTemplate && !currentElement) {
    // Template (or Element) isn't selected - don't show anything
    return null
  }
  if (currentTemplate && !currentTemplateData) {
    return (
      // Template selected, but isn't loaded yet - show spinner
      <SpinnerOverlay isActive>
        <div className="template-preview mt-3" />
      </SpinnerOverlay>
    )
  }
  return (
    <TemplatePreviewContent
      // key is used to force component re-initialization when template changes
      key={currentElement?.key || currentTemplate}
      currentElement={currentElement}
      currentTemplateData={currentTemplateData}
      currentReplaceElementId={currentReplaceElementId}
      addElement={addElement}
      allowImageUpload={allowImageUpload}
      uploaderOptions={uploaderOptions}
      initUploader={initUploader}
    />
  )
}

export default TemplatePreview
